export class Influencers {
  public carouselItems: Array<{ title: string; categories: Array<string>, active?: boolean }> = [
  {
    title: 'Brand Ambassadors',
    categories: ['Management', 'Content Creation'],
    active: true
  }, {
    title: 'Endorsed Content',
    categories: ['Radio or Social Media', 'Content Creation']
  }, {
    title: 'Unendorsed Content',
    categories: ['Radio or Social Media', 'Content Creation']
  }];
}